import PropTypes from 'prop-types';

export const clientPT = PropTypes.shape({
  createdAt: PropTypes.string.isRequired,
  dateCreated: PropTypes.string.isRequired,
  dateUpdated: PropTypes.string.isRequired,
  exist: PropTypes.bool.isRequired,
  file: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
  __v: PropTypes.number.isRequired,
  _id: PropTypes.string.isRequired,
});

export const clientsPT = PropTypes.arrayOf(clientPT);

export default clientsPT;
